export default {
  eur: (inp) => {
    if (inp === undefined) {
      return '';
    }
    if (typeof (inp) === "string") {
      inp = Number(inp);
    }
    return inp.toLocaleString("nl-NL", { style: 'currency', currency: 'EUR' });
  },
  date: (inp) => inp !== undefined && inp !== null ? inp.toLocaleDateString("nl-NL") : ''
}



// WEBPACK FOOTER //
// ./src/format.js